import axios from '../utils/request'

const Menuinfo = (id) => {
  return axios.get('GetMenuList?UserID=' + id, { })
}

export {
  Menuinfo
}
